import { defineMessages } from 'react-intl'
import { UNIT } from './unit'

const messages = defineMessages({
  barbell: {
    id: 'WeightEquipment.barbell',
    defaultMessage: 'Barbell',
    description: 'The label used for the imperial weight unit.'
  },
  lightBarbell: {
    id: 'WeightEquipment.lightBarbell',
    defaultMessage: 'Light Barbell',
    description: 'The label used for the metric weight unit.'
  },
  ezBar: {
    id: 'WeightEquipment.ezBar',
    defaultMessage: 'EZ Bar',
    description: 'The label used for the metric weight unit.'
  },
  plates: {
    id: 'WeightEquipment.plates',
    defaultMessage: 'Plates',
    description: 'The label used for the metric weight unit.'
  },
  dumbbells: {
    id: 'WeightEquipment.dumbbells',
    defaultMessage: 'Dumbbell',
    description: 'The label used for the metric weight unit.'
  },
  kettlebells: {
    id: 'WeightEquipment.kettlebells',
    defaultMessage: 'Kettlebell',
    description: 'The label used for the metric weight unit.'
  },
  cable: {
    id: 'WeightEquipment.cable',
    defaultMessage: 'Cable',
    description: 'The label used for the metric weight unit.'
  }
})

const WEIGHT_EQUIPMENT_TYPE = {
  BARBELL: 1,
  BARBELL_LIGHT: 2,
  EZ_BAR: 3,
  PLATE: 4,
  DUMBBELL: 5,
  KETTLEBELL: 6,
  CABLE: 7
}

const WEIGHT_EQUIPMENT_TYPE_TO_MESSAGE = {
  [WEIGHT_EQUIPMENT_TYPE.BARBELL]: messages.barbell,
  [WEIGHT_EQUIPMENT_TYPE.BARBELL_LIGHT]: messages.lightBarbell,
  [WEIGHT_EQUIPMENT_TYPE.EZ_BAR]: messages.ezBar,
  [WEIGHT_EQUIPMENT_TYPE.PLATE]: messages.plates,
  [WEIGHT_EQUIPMENT_TYPE.DUMBBELL]: messages.dumbbells,
  [WEIGHT_EQUIPMENT_TYPE.KETTLEBELL]: messages.kettlebells,
  [WEIGHT_EQUIPMENT_TYPE.CABLE]: messages.cable
}

const WEIGHT_EQUIPMENT_BARBELL = {
  [WEIGHT_EQUIPMENT_TYPE.BARBELL]: {
    [UNIT.IMPERIAL]: 45,
    [UNIT.METRIC]: 20
  },
  [WEIGHT_EQUIPMENT_TYPE.BARBELL_LIGHT]: {
    [UNIT.IMPERIAL]: 35,
    [UNIT.METRIC]: 16
  },
  [WEIGHT_EQUIPMENT_TYPE.EZ_BAR]: {
    [UNIT.IMPERIAL]: 22,
    [UNIT.METRIC]: 10
  }
}

const WEIGHT_EQUIPMENT_PLATES = {
  [UNIT.IMPERIAL]: [
    // 1.25,
    2.5,
    5,
    10,
    25,
    45
    // 1.25,
    // 7.5,
    // 12.5,
    // 35,
    // 50,
    // 100
  ],
  [UNIT.METRIC]: [
    // 1.25,
    2.5,
    5,
    10,
    15,
    20,
    25
    // 0.5,
    // 1.25,
    // 7.5
  ]
}

const WEIGHT_EQUIPMENT_DUMBBELL = {
  [UNIT.IMPERIAL]: [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    10,
    12,
    12.5,
    15,
    17.5,
    20,
    22.5,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    100,
    105,
    110,
    115,
    120,
    125,
    130,
    135,
    140,
    145,
    150,
    155,
    160,
    165,
    170,
    175,
    180,
    185,
    190,
    195,
    200
  ],
  [UNIT.METRIC]: [
    1,
    2,
    2.5,
    3,
    4,
    5,
    6,
    7,
    7.5,
    8,
    9,
    10,
    12.5,
    15,
    17.5,
    20,
    22.5,
    24,
    25,
    27.5,
    30,
    32,
    32.5,
    35,
    37.5,
    40,
    42.5,
    45,
    47.5,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    95,
    100
  ]
}

const WEIGHT_EQUIPMENT_KETTLEBELL = {
  [UNIT.IMPERIAL]: [
    2,
    5,
    8,
    9,
    10,
    15,
    18,
    20,
    22,
    25,
    30,
    31,
    35,
    40,
    44,
    45,
    50,
    53,
    71
  ],
  [UNIT.METRIC]: [
    4,
    5,
    6,
    8,
    10,
    12,
    14,
    15,
    16,
    20,
    24,
    28,
    32,
    36,
    40,
    44,
    48
  ]
}

const WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP = {
  [WEIGHT_EQUIPMENT_TYPE.BARBELL]: (
    WEIGHT_EQUIPMENT_BARBELL[WEIGHT_EQUIPMENT_TYPE.BARBELL]
  ),
  [WEIGHT_EQUIPMENT_TYPE.BARBELL_LIGHT]: (
    WEIGHT_EQUIPMENT_BARBELL[WEIGHT_EQUIPMENT_TYPE.BARBELL_LIGHT]
  ),
  [WEIGHT_EQUIPMENT_TYPE.EZ_BAR]: (
    WEIGHT_EQUIPMENT_BARBELL[WEIGHT_EQUIPMENT_TYPE.EZ_BAR]
  ),
  [WEIGHT_EQUIPMENT_TYPE.PLATE]: WEIGHT_EQUIPMENT_PLATES,
  [WEIGHT_EQUIPMENT_TYPE.DUMBBELL]: WEIGHT_EQUIPMENT_DUMBBELL,
  [WEIGHT_EQUIPMENT_TYPE.KETTLEBELL]: WEIGHT_EQUIPMENT_KETTLEBELL,
  [WEIGHT_EQUIPMENT_TYPE.CABLE]: WEIGHT_EQUIPMENT_KETTLEBELL
}

export {
  WEIGHT_EQUIPMENT_TYPE,
  WEIGHT_EQUIPMENT_PLATES,
  WEIGHT_EQUIPMENT_DUMBBELL,
  WEIGHT_EQUIPMENT_KETTLEBELL,
  WEIGHT_EQUIPMENT_BARBELL,
  WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP,
  WEIGHT_EQUIPMENT_TYPE_TO_MESSAGE
}
